var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 50,
    viewBox: "0 0 84 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.7576 14.8329C83.7576 32.3277 63.3621 49.7273 42.2545 49.7273C21.1469 49.7273 0.751465 32.3277 0.751465 14.8329C0.751465 -2.66186 21.1469 1.22167 42.2545 1.22167C63.3621 1.22167 83.7576 -2.66186 83.7576 14.8329Z",
    fill: "url(#paint0_linear_293_834)",
    fillOpacity: 0.4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_293_834",
    x1: 32.9856,
    y1: 0.726704,
    x2: 43.4377,
    y2: 50.6643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.223958,
    stopColor: "#7DA2B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91A1A7",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCover);
export default __webpack_public_path__ + "static/media/cover.0bb3f8a33e2b579e8ed3bd2d4c01c541.svg";
export { ForwardRef as ReactComponent };